import { Center, Box, Stack, Flex, Text } from '@chakra-ui/react'
import { ErrorFallback } from '@components/Fallback'
import { UsageDateRange } from '@features/usage/components/DatePickers/UsageDateRange'
import { ProjectSessionsOverview } from '@features/usage/components/sessions/ProjectSessionsOverview'
import { UsageTabbedNav } from '@features/usage/components/UsageTabbedNav'
import { FallbackRender, ErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

const fallback: FallbackRender = (props) => (
  <ErrorFallback {...props}>
    <Text>
      We're unable to display your usage overview, if the problem persists
      contact the Cloudmix team
    </Text>
  </ErrorFallback>
)

const UsageRoute = () => (
  <Center>
    <Box w={'full'} h={'full'} maxW={'5xl'}>
      <UsageTabbedNav />
      <Stack py={4} spacing={6}>
        <Flex justify={'space-around'}>
          <Box w={'full'} maxW={'lg'}>
            <UsageDateRange />
          </Box>
        </Flex>
        <Center>
          <ErrorBoundary fallback={fallback}>
            <ProjectSessionsOverview />
          </ErrorBoundary>
        </Center>
      </Stack>
    </Box>
  </Center>
)

export const Route = createFileRoute('/_auth/o/$orgId/usage/overview')({
  component: UsageRoute,
  beforeLoad: () => ({ getTitle: () => 'Usage' }),
})
